import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { QrcodeStream } from 'vue-qrcode-reader';
import LiquorTree from 'liquor-tree';
import { field } from 'devexpress-reporting/designer/controls/metadata/pivotgrid/sortBySummary';

const toLower = text => {
  return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.name).includes(toLower(term)))
  }

  return items
}

export default {
  name: 'Element',
  props: {
    dataObj: {
      type: Object,
      default: []
    },
    maintenanceActivityId: {
      type: Number,
      default: -1
    },
    enableElementFieldCapturing: {
      type: Boolean,
      default: false
    },
  },
  components: {
    QrcodeStream,
    GoogleMapElementComp: require('../../components/maps/gMapElement.vue').default,
    MapComp: require('../../components/maps/map.vue').default,
    CaptureElementComp: require('../../components/maps/captureElementMap.vue').default,
    LrsComp: require('./lrs.vue').default,
    loadingSnippet: require('../../common/loadingSnippet/loadingSnippet.vue').default,
    CustomFieldsComp: require('../../components/customFields.vue').default,
    ElementListSelect: require('@/customcontrols/elementListSelectForm.vue').default,
  },
  data: function () {
    return {
      modalListDisplay: {displayField: "name", key:"id"},
      deleteElementConfirmation: false,
      gisSettings: null,
      options: { pageSize: 10000, total: 0, page: 1, count: 0 },
      elementData: {
        elemenTypeDisabled: true,
        elementTypeId: -1,
        elementId: -1,
        readonly: false
      },
      elementTypes: [],
      elementType: {
        gisLayerName: '',
        moduleId: '',
        name: '',
        typeId: 0
      },
      bAllowMultiSelect: false,
      bGPSFiltering: false,
      bQrCodeScan: false,
      element: {
        externalRef: '',
        id: 0,
        name: '',
        typeId: 0
      },
      elements: [],
      qrElements: [],
      hierarchyLinks: [],
      hierarchyLink: {
        accountingGroup: null,
        commissionDate: '0001-01-01T00:00:00',
        elementId: 0,
        elementTypeId: 0,
        externalFinRef: null,
        groupCategoryDescription: null,
        groupId: 0,
        id: 0,
        linkType: 0,
        locationId: -1,
        parentElementId: 0,
        parentElementTypeId: 0,
        system: false,
        text: '',
        updateStatus: 0
      },
      totalRowTree: 0,
      treeSelection: [],
      treeFilter: '',
      treeFilterAux: '',
      bShowTree: false,
      treeOptions: {
        multiple: false,
        checkbox: false,
        checkOnSelect: false,
        autoCheckChildren: false,
        parentSelect: false,
        keyboardNavigation: true,
        deletion: false,
        filter: {
          plainList: true
        }
      },
      treeData: [],
      qrCodeManual:'',
      bHasLocation: true,
      bPortalGis: true,
      bGMapSelect: false,
      bHierarchySelect: false,
      bMapCaptureElement: false,
      bHierarchyCaptureElement: false,
      bGMapZoom: false,
      gMapData: {
        elementTypeId: -1,
        elementId: -1,
        longitude: null,
        latitude: null,
        gisSettings: null,
      },
      mapData: {
        elementTypeId: -1,
        elementId: -1,
        gisSettings: null,
      },
      geoLocation: null,
      errorMessage: '',
      placeHolder: '',
      message: '',
      HierarchyKey: 0,
      bShowZoomGIS: false,
      allowLrs: false,
      captureMissingElemSelect: false,
      captureOtherElemSelect: false,
      enableCapturing: false,
      capturedElement: {},
      customeFieldValues: [],
      bCaptureElementMap: false,
      previousElem: {},
      deleteParam: {},
      showCaptureMissingJobcardElementDialog: false,
      bCaptureMissingJobcardElementDialog: false,
      showCaptureOtherMissingElementDialog: false,
      bCaptureOtherMissingElementDialog: false,
      disableElementFieldCapturing: false,
      fieldElementType: null,
      systemElementType: null,
      
      bElementTypesForCaptureMissingElementDialog: false,
      
      
      capturedElements: [],
      captureElements: {
        currentCaptureMissingElementTab: 'tab-elementTypes',
        colorArray: ['#FF6633', '#4DB380', '#FF33FF', '#6666FF', '#00B3E6',
          '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
          '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
          '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
          '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
          '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
          '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
          '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
          '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
          '#E64D66', '#FFB399', '#FF4D4D', '#99E6E6', '#FFFF99'],
        elements: [],
        selectedElementIdx: -1,
        searchElementType: null,
        searchedElementType: [],
        selectedElementType: {},
        enableMapTab: false,
        enableElementDataTab: false,
        mapLoading: false,
        askForCaptureAnotherElements: false
      },
      createdJobCardElementId: -1,

      componentKey: 0
    }
    
  },
  computed: {
    elementTypeId: function () {
      return this.elementData.elementTypeId;
    },
    elemTypeId: function () {
      return this.elementData.elementTypeId;
    },
    //selectedElementId: function () {
    //  return this.gMapData.elementId;
    //}
  },
  watch: {
    deleteElementConfirmation: function (value) {
      if (value == false)
        this.deleteParam = {}
    },
    bMapCaptureElement: function (value) { },
    bHierarchyCaptureElement: function (value) {
      //if (value)
        //this.gMapCaptureElement();
    },
    bGMapSelect: function (value) {
      if (value)
        this.gMapSelectElement();
    },
    bHierarchySelect: function (value) {
      if (value)
        this.getHierarchyLinks();
      else
        this.hierarchyLinks = [];
    },
    bGPSFiltering: function (value) {
      if (value)
        this.getElements();
    },
    element: function (value) {
      if (!value)
        return;

      this.canDeleteElement(this.previousElem);

      this.elementData.elementId = value.id;
      
      this.$root.$emit('element_set_id');
      this.previousElem = value;
    },
    elementTypeId: function (value) {
      if (value > -1) {
        this.getElements();
      }
    },
    elementType: function (value) {
      if (!value) {
        this.allowLrs = false;
        return;
      }
      
      if (this.elementData.availableLrsEventTypes != null && this.elementData.availableLrsEventTypes.length > 0 && this.elementData.availableLrsEventTypes[value.typeId]) {
        this.allowLrs = true;
      } else {
        this.allowLrs = false;
      }

      this.elementData.elementTypeId = value.typeId;

      if (value.geometryType == -1) {
        this.enableCapturing = false;
      } else {
        this.enableCapturing = this.dataObj.enableElementFieldCapturing != null ? JSON.parse(JSON.stringify(this.dataObj.enableElementFieldCapturing)) : false;
      }
    },
    captureOtherElemSelect: function (value) {
      if (value)
        this.CaptureOtherElemSelectFunc();
    },
    captureMissingElemSelect: function (value) {
      if (value)
        this.captureMissingElemSelectFunc();
    },
    showCaptureMissingJobcardElementDialog: function (value) {
      if (value) {
        this.prepareCaptureMissingJobcardElement();
      }
    },
    bCaptureMissingJobcardElementDialog: function (value) {
      this.showCaptureMissingJobcardElementDialog = value;

      if (!value)
        this.gMapData.captureMissingJobcardElement = false;
    },
    showCaptureOtherMissingElementDialog: function (value) {
      if (value) {
        this.prepareCaptureOtherMissingElement();
      }
    },
    bCaptureOtherMissingElementDialog: function (value) {
      this.showCaptureOtherMissingElementDialog = value;

      if (!value) {
        this.gMapData.captureOtherMissingElement = false;

        this.captureElements = {
          currentCaptureMissingElementTab: 'tab-elementTypes',
          colorArray: ['#FF6633', '#4DB380', '#FF33FF', '#6666FF', '#00B3E6',
            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
            '#E64D66', '#FFB399', '#FF4D4D', '#99E6E6', '#FFFF99'],
          elements: [],
          selectedElementIdx: -1,
          searchElementType: null,
          searchedElementType: [],
          selectedElementType: {},
          enableMapTab: false,
          enableElementDataTab: false,
          mapLoading: false,
        }
      }
    },
    //selectedElementId: function (value) {
    //  if (value > 0) {
    //    this.bGMapSelect = false;
    //    this.element = this.elements.filter(item => item.id === value)[0];
    //  }
    //},
  },
  created() {
    this.$root.$on('record_selected_from_list_select', (item) => this.element = item);
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    var geo = navigator.geolocation.getCurrentPosition(
      (pos) => { this.geoLocation = pos; },
      (err) => { this.$alertMsg(err.message); },
      geoOptions
    );
    this.getElementTypes();
    this.$root.$on('element_data_updated', this.init);
    this.$root.$on('element_selected', this.elementIsSelected);
    this.init();
    //this.getGisSettings();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.elementData = this.dataObj;
        this.elementData.elemenTypeDisabled = this.elementData.elementTypeId > -1;
        //this.options.count = 0;
        //this.elements = [];
        if (this.elementData.elementId > 0)
          this.getElement();
        else {
          this.element = null;
        }
        if (this.elementData.elementTypeId > 0) {
          //this.getElements();
          if (this.elementTypes.length > 0) {
            this.elementType = this.elementTypes.filter(p => p.typeId === this.elementData.elementTypeId)[0];
          }
        }
        this.clearHierarchy();
      });
    },
    searchTreeData() {
      this.treeFilter = this.treeFilterAux;
    },
    clearHierarchy() {
      this.hierarchyLink = {
        accountingGroup: null,
        commissionDate: '0001-01-01T00:00:00',
        elementId: 0,
        elementTypeId: 0,
        externalFinRef: null,
        groupCategoryDescription: null,
        groupId: 0,
        id: 0,
        linkType: 0,
        locationId: -1,
        parentElementId: 0,
        parentElementTypeId: 0,
        system: false,
        text: '',
        updateStatus: 0
      };
      this.bShowTree = true;
      this.treeFilter = '';
      this.treeFilterAux = '';
    },
    selectionChanges(node, instanceId) {
      //console.log(node);
      //console.log(instanceId);
      //if (this.changeSelection) {
      //  this.$emit('itemSelected', this.elementPropertiesGroup, this.elementPropertiesRowIndex, node)
      //  //for (var i = 0; i < this.items.length; i++) {
      //  //  this.items[i].selected = false;

      //  //  if (this.items[i].id == node.id) {
      //  //    this.items[i].selected = true;
      //  //    console.log('node', node);

      //  //    console.log('parent', this.parent.elementProperties.properties);
      //  //  }
      //  //}
      //}
      //else {
      //  this.setParentModel(node.id);
      //}
    },
    getUniqueId() {
      return this.iCurrentCount++;
    },
    getNodeImage(id) {
      var elementType = this.elementTypes.filter(t => t.id == id)[0];
      return elementType ? elementType.imageWeb : '';
    },
    selectNodes() {
      var tree = this.$refs.tree;
      var selection = tree.findAll({ state: { checked: false } });
      selection.check();
    },
    unselectNodes() {
      var tree = this.$refs.tree;
      var selection = tree.findAll({ state: { checked: true } });
      selection.uncheck();
    },
    viewSelectedTree() {
      var tree = this.$refs.tree;
      this.treeSelection = tree.findAll({ state: { checked: true } });
      this.iSelectedCount = this.treeSelection.length;

      this.active = 'second';
      this.first = true;
      this.second = false;
      this.third = false;
      this.fourth = false;
    },
    getClass(id) {
      return (id === this.iValueEditIndex) ? 'selected' : 'readings';
    },
    populateTree() {
      this.treeOptions = {
        multiple: false,
        checkbox: true,
        checkOnSelect: false,
        autoCheckChildren: true,
        parentSelect: false,
        keyboardNavigation: true,
        deletion: false,
        filter: {
          plainList: false
        }
      };
      this.iCurrentCount = 0;
      this.treeData = [];
      this.hierarchyLinks.forEach(item => {
        this.treeData.push(this.createNodeTree(item));
      });
      this.bShowTree = true;
      this.HierarchyKey++;
    },
    createNodeTree(assetNode) {
      var node = {
        id: this.getUniqueId(),
        text: assetNode.Name,
        data: {
          id: this.getUniqueId(),
          elementId: assetNode.ElementId,
          elementTypeId: assetNode.ElementTypeId
        },
        children: [],
        state: {
          selected: false,
          selectable: true,
          checked: false,
          expanded: this.bExpandNodes,
          disabled: false,
          visible: true,
          indeterminate: false,
          matched: false,
          editable: true,
          dragging: false,
          draggable: true,
          dropable: true
        }
      };
      assetNode.Children.forEach(item => {
        node.children.push(this.createNodeTree(item));
      });
      return node;
    },
    onNodeSelected(node) {
      //console.log(node.text)
    },
    onNodeChecked(node) {
      node.states.expanded = true;
      var tree = this.$refs.tree;
      this.iSelectedCount++;
      if (node.children.length === 0) {
        this.hierarchyLink = node.data;
        this.element = this.elements.filter(item => item.id === node.data.elementId)[0];
        this.bShowTree = false;
        this.bHierarchySelect = false;
      }
    },
    onNodeUnchecked(node) {
      node.states.expanded = true;
      var tree = this.$refs.tree;
      this.iSelectedCount--;
    },
    assetsPageChange(pInfo) {
      var parameter = {
        Options: {
          PageSize: pInfo.pageSize,
          Page: pInfo.pageNumber,
          FilterText: this.search
        },
        ElementTypeId: this.elementTypeId,
        GroupId: this.groupId,
        LocationId: this.locationId,
      };
      this.bShowTree = false;
      //this.getCommonData(parameter);
    },
    elementIsSelected() {
      this.bGMapSelect = false;
      this.element = this.elements.filter(item => item.id === this.gMapData.elementId)[0];
    },
    setJobcardLocation() {
      //console.log('setJobcardLocation');
      this.bHasLocation = !this.bHasLocation;
    },
    getGisLayerName() {
      var res = this.elementTypes.filter(t => t.typeId == this.elementData.elementTypeId);
      return (res.length == 1) ? res[0].gisLayerName : "";
    },
    onDecode(content) {
      this.bQrCodeScan = false;
      this.GetElementsByQrCode(content);
    },
    onInit(promise) {
      promise.then(() => {
        //console.log('QR Reader Successfully initilized! Ready for scanning now!')
      })
        .catch(error => {
          if (error.name === 'NotAllowedError') {
            this.errorMessage = 'Hey! I need access to your camera'
          } else if (error.name === 'NotFoundError') {
            this.errorMessage = 'Do you even have a camera on your device?'
          } else if (error.name === 'NotSupportedError') {
            this.errorMessage = 'Seems like this page is served in non-secure context (HTTPS, localhost or file://)'
          } else if (error.name === 'NotReadableError') {
            this.errorMessage = 'Couldn\'t access your camera. Is it already in use?'
          } else if (error.name === 'OverconstrainedError') {
            this.errorMessage = 'Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?'
          } else {
            this.errorMessage = 'UNKNOWN ERROR: ' + error.message
          }
        })
    },
    searchQrManually() {
      this.bQrCodeScan = false;
      this.GetElementsByQrCode(this.qrCodeManual);
    },
    gMapSelectElement() {
      this.gMapData.elementTypeId = this.elementData.elementTypeId;
      this.gMapData.elementId = -1;
      this.gMapData.latitude = null;
      this.gMapData.longitude = null;
      this.gMapData.gisSettings = null;
      //this.gMapData.latitude = -25.476418549935577;
      //this.gMapData.longitude = 30.97445231420286;
    },
    getHierarchyLinks() {
      //console.log("maintId",this.maintenanceActivityId);
      let param = '?elementTypeId=' + this.elementData.elementTypeId;
      
      if (this.maintenanceActivityId >= 0)
        param = param + '&maintenanceActivityId=' + this.maintenanceActivityId;

      this.$store.state.notifier.asyncBlock(
        axios.get('/Element/GetHierarchyLinks' + param), // + this.elementData.elementTypeId),
        resp => {
          if (resp.status == 200) {
            this.hierarchyLinks = resp.data;
            this.populateTree();
          }
          else
            this.$alertMsg(resp.statusText)
        },
        err => {
          this.$alertMsg(err.response.data);
        },
        this.$t('common.LoadingHierarchylinks')
      );
    },
    zoomToElement() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/GIS/GetZoomToElementUrl', { ElementType: this.element.typeId, ElementId: this.element.id }),
        resp => {
          if (resp.status == 200)
            if (resp.data.data.status == 0) {
              var url = resp.data.url;
              window.open(url, '_blank');
            }
            else
              this.$alertMsg(resp.data.data.text)
        },
        err => {
          this.$alertMsg(err.response.data);
        }
      );
    },
    getGisSettings() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/GIS/GetGisSettings'),
        resp => {
          if (resp.status == 200) {
            this.gisSettings = resp.data;

            this.gMapData.gisSettings = resp.data;

            if (resp.data.data.status == 0)
              this.bShowZoomGIS = resp.data.settings.defaultMapId !== -1;
            else
              this.$alertMsg(resp.data.data.text);
          }
          else
            this.gisSettings = null;
          //this.captureMissingElemSelectFunc(); //tbi
        },
        err => {
          this.$alertMsg(err.response.data);
        }
      );
    },
    gMapZoomToElement() {
      this.gMapData.elementTypeId = this.elementData.elementTypeId;
      this.gMapData.elementId = this.elementData.elementId;
      this.gMapData.latitude = null;
      this.gMapData.longitude = null;
      this.bGMapZoom = true;
    },
    getElementFromQR(qrElementId) {

      let param = {
        params: {
          elementTypeId: this.element.typeId, //this.jobcardData.elementTypeId,
          elementId: qrElementId,  
        }
      }
      axios.post('/Element/GetElement', param)
        .then(response => {
          if (response.status == 200) {
            this.element = response.data.item;
            this.$alertMsg(this.$t('messages.QRCodeElementSetSuccess'), 2);
          }
          else {
            this.$alertMsg(this.$t('messages.QRCodeElementFailure'), 4);
          }
        })
        .catch(err => {
          err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$alertMsg(err.data.data.text);
        });

      /*this.$store.state.notifier.asyncBlock(
        axios.post('/Element/GetElement', { params: { elementTypeId: this.jobcardData.elementTypeId, elementId: qrElementId } }),
        response => {
          if (response.status == 200) {
            this.element = response.data.item;
            this.$alertMsg(this.$t('messages.QRCodeElementSetSuccess'), 0);
          }
          else {
            this.$alertMsg(this.$t('messages.QRCodeElementFailure'), 1);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Getting Element'
      );*/
    },
    GetElementsByQrCode(qrElementId) {
        axios.get('/Element/GetElementsByQrCode', {
          params: {
            qrCode: qrElementId,
            pageSize: 1000,
            page: 1,
          }
        })
          .then(response => {
            if (response.status == 200 && response.data.items && response.data.items.length > 0) {
              this.qrElements = response.data.items;
              let element = this.qrElements[0];
              if (this.elementData.elemenTypeDisabled === true && this.elementData.elementTypeId !== element.typeId) {
                this.$alertMsg(this.$t('messages.QRCodeElementFailureType'), 4);
                return;
              }
              else {
                this.element = element;
                this.elementData.elementTypeId = this.element.typeId;
                this.$alertMsg(this.$t('messages.QRCodeElementSetSuccess'), 2);
              }
            }
            else {
              this.$alertMsg(this.$t('messages.QRCodeElementFailure'), 4);
            }
          })
          .catch(err => {
            err.response.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
              this.$alertMsg(err.response.data);
          });
    },
    getElementTypes() {
      this.elementTypes = this.$store.state.elementTypesPlain;

      if (this.elementData.elementTypeId > 0 && this.elementTypes.length > 0) {

        this.elementType = this.elementTypes.filter(p => p.typeId === this.elementData.elementTypeId)[0];

        if (this.elementType.geometryType == -1) {
          this.enableCapturing = false;
        } else {
          this.enableCapturing = this.dataObj.enableElementFieldCapturing != null ? JSON.parse(JSON.stringify(this.dataObj.enableElementFieldCapturing)) : false;
        }

        if (this.enableCapturing) {
          if (this.elementType.isSystem)
            this.getFieldElementType();
          else
            this.getSystemElementType();
        }
      }
    },
    getElement() {

      axios.get('/Element/GetElement?elementTypeId=' + this.elementData.elementTypeId + '&elementId=' + this.elementData.elementId)
        .then(response => {
          if (response.status == 200) {
            this.element = response.data.item;
          }
          else {
            this.$alertMsg(response.data);
          }
        })
        .catch(err => {
          err.response.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$alertMsg(err.response.data);
        });
    },
    getElements() {
      if (this.$store.state.csAppsOfflineMode) {
        this.elements = [];

        this.elements.push({
          externalRef: null,
          id: this.dataObj.elementId,
          name: this.dataObj.elementRef,
          typeId: this.dataObj.elementTypeId
        });

        this.options.count = this.dataObj.elementId > 0 ? 1 : 0;
        return;
      }

      var parameter = {
        FilterByCurrentLocation: false,
        ElementTypeId: this.elementData.elementTypeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: this.options,
      };

      if (this.maintenanceActivityId >= 0)
        parameter['MaintenanceActivityId'] = this.maintenanceActivityId;

      if (this.geoLocation != null && this.bGPSFiltering === true) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }

      axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.status == 200) {
            this.elements = response.data.items;

            this.options.count = response.data.count;
          }
        })
        .catch(err => {
          err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$alertMsg(err.data.data.text);
        })
    },
    captureMissingElemSelectFuncClose(disableCapture, captElement) {
      this.bCaptureElementMap = false;
      this.captureMissingElemSelect = false;

      
      if (disableCapture == true) {
        this.dataObj.capturedElement = {};
        return;
      }

      if (captElement.elementType == null || captElement.elementType == {})
        return;

      this.dataObj.capturedElement = captElement;
      this.elementType = captElement.elementType;

      this.dataObj.elementId = captElement.elementId;
      this.dataObj.elementTypeId = captElement.elementType.typeId;

      this.elementData.elementId = captElement.elementId;
      this.elementData.elementTypeId = captElement.elementType.typeId;
    },
    captureMissingElemSelectFunc() {

      this.mapData.elementTypeId = this.dataObj.elementTypeId;
      this.mapData.elementId = -1;
      this.mapData.gisSettings = this.gisSettings;

      this.bCaptureElementMap = true;
      //this.GetFieldElementType();
      //this.GetElementsByLngLat(this.dataObj.elementTypeId);
      
    },
    async prepareCaptureMissingJobcardElement() {
      if (this.enableCapturing) {
        if (this.elementType.isSystem)
          await this.getFieldElementType();
        else
          await this.getSystemElementType();
      }

      this.gMapData.elementTypeId = this.dataObj.elementTypeId;
      this.gMapData.elementId = this.dataObj.elementId == 0 ? -1 : this.dataObj.elementId;
      this.gMapData.fieldElementType = this.fieldElementType;
      this.gMapData.systemElementType = this.systemElementType;
      this.gMapData.linkedFieldTypeId = this.elementTypes.filter(a => a.typeId == this.dataObj.elementTypeId)[0].isSystem ? this.fieldElementType.typeId : -1;
      this.gMapData.elementType = this.elementType;
      this.gMapData.captureMissingJobcardElement = true;
      this.gMapData.markers = [];
      this.bCaptureMissingJobcardElementDialog = true;
    },
    prepareCaptureOtherMissingElement() {
      // open element types dialog
      //this.searched = this.elementTypes;
      //this.bElementTypesForCaptureMissingElementDialog = true;

      //console.log('prepareCaptureOtherMissingElement', this.dataObj);
      //console.log(this.fieldElementType);
      //console.log(this.systemElementType);

      //this.gMapData.elementTypeId = this.dataObj.elementTypeId;
      //this.gMapData.elementId = this.dataObj.elementId;
      //this.gMapData.fieldElementType = this.fieldElementType;
      //this.gMapData.systemElementType = this.systemElementType;
      //this.gMapData.linkedFieldTypeId = this.elementTypes.filter(a => a.typeId == this.dataObj.elementTypeId)[0].isSystem ? this.fieldElementType.typeId : -1;
      //this.gMapData.elementType = this.elementType;
      //this.gMapData.captureMissingJobcardElement = true;
      //this.bCaptureMissingJobcardElementDialog = true;

      this.captureElements.selectedElementIdx = 0;

      this.captureElements.elements.push({
        elementType: {},
        fieldElementType: {},
        systemElementType: {},
        linkedFieldTypeId: -1,
        markers: [],
        customFieldsGroups: [],
        customFields: []
      });

      this.captureElements.searchedElementType = this.elementTypes;
      this.gMapData.elementTypeId = -1;// this.selectedElementType.isSystem ? this.fieldElementType.typeId : this.selectedElementType.typeId;
      this.gMapData.fieldElementType = {};// this.fieldElementType;
      this.gMapData.systemElementType = {};// this.systemElementType;
      this.gMapData.linkedFieldTypeId = null;// this.elementTypes.filter(a => a.typeId == this.selectedElementType.typeId)[0].isSystem ? this.fieldElementType.typeId : -1;
      this.gMapData.elementType = null;// this.selectedElementType.isSystem ? this.fieldElementType : this.selectedElementType;
      this.gMapData.missingElementIndex = 0;
      this.gMapData.colorArray = this.colorArray;
      this.gMapData.captureOtherMissingElement = true;
      this.bCaptureOtherMissingElementDialog = true;
      //this.search = '';
    },
    checkElementMapAndDataTabDisable() {
      if (this.captureElements.elements[this.captureElements.selectedElementIdx].elementType.typeId == undefined)
        return true;

      return false;
    },
    captureOtherElemSelectFunc() {
      this.GetCustomFieldValues();
    },
    canDeleteElement(elem) {
      if (this.deteParam != {})
        return;

      this.deleteParam = {
        ElementTypeId: elem.typeId,
        ElementId: elem.id,
        ApplicationId: this.dataObj.appId,
      }

      axios.post('/OmJobcardActivity/CanDeleteElement', this.deleteParam)
        .then(resp => {
          if (resp.data == true) {
            this.deleteElementConfirmation = true;
          } else {
            this.deleteElementConfirmation = false;
            this.deleteParam = {};
          }
        })
        .catch(() => this.deleteElementConfirmation = false);

    },
    deleteElement() {
      //console.log("deleteparam", this.deleteParam)
      axios.post('/OmJobcardActivity/DeleteElement', this.deleteParam)
        .then(resp => {
          this.$alertMsg(this.$t('jobcardDetail.elementDeletedSuccessully'),2);
        })
        .catch(err => {
          this.$alertMsg(err.data);
        })
        .finally(() => this.deleteParam = {});
    },
    async getFieldElementType() {
      await axios.get('/Element/GetFieldElementType?elementTypeId=' + this.dataObj.elementTypeId)
        .then(resp => {
          if (resp.data == '' || resp.data == null) {
            this.disableElementFieldCapturing = true;
          } else {
            this.disableElementFieldCapturing = false;
            this.fieldElementType = resp.data;
            return;

            //if (this.captureElements.selectedElementType != {}) {
            //  this.showMapForCaptureMissingElement();
            //}
          }
        })
        .catch(err => {
          this.$alertMsg(err.message);
        })
        //.finally(() => this.getMapElements());
    },
    async getSystemElementType() {
      await axios.get('/Element/GetSystemElementType?fieldTypeId=' + this.dataObj.elementTypeId)
        .then(resp => {
          if (resp.data == '' || resp.data == null) {
            this.disableElementFieldCapturing = true;
          } else {
            this.disableElementFieldCapturing = false;
            this.systemElementType = resp.data;

            return;

            //if (this.selectedElementType != {}) {
            //  this.showMapForCaptureMissingElement();
            //}
          }
        })
        .catch(err => {
          if (err.response.data)
            this.$alertMsg(err.response.data);
        })
        //.finally(() => this.getMapElements());
    },
    createElement(changeElement) {
      const mrks = this.$refs['captureElementComponent'].markers.filter(a => !a.isCenter && a.marker);

      if (mrks.length == 0 && this.gMapData.elementType.geometryType == 0) {
        this.$alertMsg(this.$t('jobcardDetail.captureElementOfTypePointMustHasOneMarker'));
        return;
      } else if (mrks.length == 1 && this.gMapData.elementType.geometryType == 1) {
        this.$alertMsg(this.$t('jobcardDetail.captureElementOfTypeLineMustHasTwoMarkersAtLeast'));
        return;
      } else if (mrks.length == 2 && this.gMapData.elementType.geometryType == 2) {
        this.$alertMsg(this.$t('jobcardDetail.captureElementOfTypeAreaMustHasThreeMarkersAtLeast'));
        return;
      }

      const points = [];

      this.$refs['captureElementComponent'].markers.filter(a => !a.isCenter && a.marker).forEach(m => {
        points.push({
          X: m.position.lng,
          Y: m.position.lat
        });
      });

      const customFields = [];
      this.$refs['captureElementComponent'].customFields.forEach(m => {
        customFields.push({
          customFieldId: m.customFieldId,
          strValue: m.strValue,
          intValue: m.intValue,
          dblValue: m.dblValue,
          dateValue: m.dateValue,
          dateTimeValue: m.dateTimeValue,
          dataId: m.dataId
        });
      });


      const parameters = {
        elementTypeId: this.elementTypes.filter(a => a.typeId == this.dataObj.elementTypeId)[0].isSystem ? this.fieldElementType.typeId : this.dataObj.elementTypeId,
        ref: '',
        CustomFieldValues: customFields,
        Geometry: points
      };

      axios.post('/Element/Create', parameters)
        .then(resp => {
          if (resp.status == 200) {
            this.createdJobCardElementId = resp.data;

            if (changeElement) {
              if (this.gMapData.linkedFieldTypeId > 0)
                this.elementType = this.elementTypes.filter(p => p.typeId === this.gMapData.linkedFieldTypeId)[0];

              this.getCreatedElements(this.elementType.typeId, resp.data);
            }
            else {
              this.bCaptureMissingJobcardElementDialog = false;
              this.bCaptureOtherMissingElementDialog = false;
              this.$alertMsg(this.$t('messages.elementHasBeenCreatedSuccessfully'));
            }
          } else {
            console.log(resp);
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    getCreatedElements(typeId, id) {
      var parameter = {
        FilterByCurrentLocation: false,
        ElementTypeId: typeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0
      };

      axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.status == 200) {
            this.elements = response.data.items;
            this.element = this.elements.filter(item => item.id === id)[0];
            this.bCaptureMissingJobcardElementDialog = false;
            this.bCaptureOtherMissingElementDialog = false;
            this.$alertMsg(this.$t('messages.elementHasBeenCreatedSuccessfully'), 2);
          }
        })
        .catch(err => {
          err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$alertMsg(err.data.data.text);
        })
    },
    elementTypeSelected() {
      console.log(this.selectedElementType);
      
      if (!this.selectedElementType.typeId) {
        this.$alertMsg(this.$t('CaptureElement.noElementTypeSelected'));
        return;
      }

      this.bElementTypesForCaptureMissingElementDialog = false;

      this.captureElements.selectedElementIdx++;

      if (this.selectedElementType.isSystem)
        this.getFieldElementType();
      else
        this.getSystemElementType();
    },
    showMapForCaptureMissingElement() {
      this.gMapData.elementTypeId = this.selectedElementType.isSystem ? this.fieldElementType.typeId : this.selectedElementType.typeId;
      this.gMapData.fieldElementType = this.fieldElementType;
      this.gMapData.systemElementType = this.systemElementType;
      this.gMapData.linkedFieldTypeId = this.elementTypes.filter(a => a.typeId == this.selectedElementType.typeId)[0].isSystem ? this.fieldElementType.typeId : -1;
      this.gMapData.elementType = this.selectedElementType.isSystem ? this.fieldElementType : this.selectedElementType;
      this.gMapData.missingElementIndex = this.captureElements.selectedElementIdx;
      this.gMapData.colorArray = this.colorArray;
      this.gMapData.captureOtherMissingElement = true;
      this.bCaptureOtherMissingElementDialog = true;
      this.search = '';
    },
    searchOnTable() {
      this.captureElements.searchedElementType = searchByName(this.elementTypes, this.captureElements.searchElementType)
    },
    async onSelectElementType(item) {
      if (!item)
        return;

      this.captureElements.selectedElementType = item;
      this.captureElements.currentCaptureMissingElementTab = 'tab-map';
      this.captureElements.mapLoading = true;
      this.captureElements.enableMapTab = true;

      if (this.captureElements.selectedElementType.isSystem)
        await this.getFieldElementType();
      else
        await this.getSystemElementType();

      this.captureElements.elements[this.captureElements.selectedElementIdx] = {
        elementType: item.isSystem ? this.fieldElementType : item,
        fieldElementType: this.fieldElementType,
        systemElementType: this.systemElementType,
        linkedFieldTypeId: item.isSystem ? this.fieldElementType.typeId : -1,
        markers: [],
        customFieldsGroups: [],
        customFields: []
      };

      this.getCustomFields(this.captureElements.elements[this.captureElements.selectedElementIdx].linkedFieldTypeId > 0 ? 
        this.captureElements.elements[this.captureElements.selectedElementIdx].linkedFieldTypeId :
        this.captureElements.elements[this.captureElements.selectedElementIdx].elementType.typeId);

      this.captureElements.searchElementType = '';
      this.fillMapObj(this.captureElements.selectedElementIdx);

      this.checkElementMapAndDataTabDisable();
    },
    fillMapObj(idx) {
      this.gMapData.elementTypeId = this.captureElements.elements[idx].elementType.typeId;
      this.gMapData.fieldElementType = this.captureElements.elements[idx].fieldElementType;
      this.gMapData.systemElementType = this.captureElements.elements[idx].systemElementType;
      this.gMapData.elementType = this.captureElements.elements[idx].elementType;
      this.gMapData.linkedFieldTypeId = this.captureElements.elements[idx].linkedFieldTypeId;
      this.gMapData.missingElementIndex = idx;
      this.gMapData.colorArray = this.captureElements.colorArray
      this.gMapData.captureOtherMissingElement = true;
      this.gMapData.markers = this.captureElements.elements[idx].markers;
      
      this.captureElements.mapLoading = false;
    },
    cancelSelectElementType() {
      this.selectedElementType = {};
      this.bElementTypesForCaptureMissingElementDialog = false;
      this.showCaptureOtherMissingElementDialog = false;
      this.search = '';
    },
    changeCaptureMissingElementTab(e) {
      this.captureElements.currentCaptureMissingElementTab = e;
    },
    markerColor(idx) {
      return 'color: ' + this.captureElements.colorArray[idx] + '';
    },
    capturedElementSelected(idx) {
      this.captureElements.selectedElementIdx = idx;
      this.$refs.captureElementComponent.addCurrentElementMarker2(this.captureElements.elements[idx].markers);

      this.fillMapObj(idx);
      this.componentKey++;
    },
    getCustomFields(typeId) {
      axios.get('/Element/GetCustomFields?elementTypeId=' + typeId)// (this.dataObj.linkedFieldTypeId > 0 ? this.dataObj.linkedFieldTypeId : this.dataObj.elementTypeId))
        .then(resp => {
          this.captureElements.elements[this.captureElements.selectedElementIdx].customFields = resp.data;

          this.captureElements.elements[this.captureElements.selectedElementIdx].customFieldsGroups = [];

          for (var i = 0; i < resp.data.length; i++) {
            if (this.captureElements.elements[this.captureElements.selectedElementIdx].customFieldsGroups.filter(a => a == resp.data[i].groupName).length == 0)
              this.captureElements.elements[this.captureElements.selectedElementIdx].customFieldsGroups.push(resp.data[i].groupName);
          }
        })
        .catch(err => {
          this.$alertMsg(err.message);
        });
    },
    getGroupFields(grp) {
      const fields = {
        items: this.captureElements.elements[this.captureElements.selectedElementIdx].customFields.filter(a => a.groupName == grp)
      };

      return fields;
    },
    saveCapturedElements() {
      const totalMarkers = this.captureElements.elements.reduce((res, a) => res + a.markers.length, 0);

      //if (totalMarkers) {
      //  this.$alertMsg(this.$t('CaptureElement.noElementsCaptured'));
      //  return;
      //}

      for (var i = 0; i < this.captureElements.elements.length; i++) {
        const mrks = this.captureElements.elements[i].markers;

        if (mrks.length == 0 && this.captureElements.elements[i].elementType.geometryType == 0) {
          this.$alertMsg(this.$t('jobcardDetail.captureElementOfTypePointMustHasOneMarker'));
          return;
        } else if (mrks.length == 1 && this.captureElements.elements[i].elementType.geometryType == 1) {
          this.$alertMsg(this.$t('jobcardDetail.captureElementOfTypeLineMustHasTwoMarkersAtLeast'));
          return;
        } else if (mrks.length == 2 && this.captureElements.elements[i].elementType.geometryType == 2) {
          this.$alertMsg(this.$t('jobcardDetail.captureElementOfTypeAreaMustHasThreeMarkersAtLeast'));
          return;
        }

        const points = [];

        this.captureElements.elements[i].markers.forEach(m => {
          points.push({
            X: m.position.lng,
            Y: m.position.lat
          });
        });

        const customFields = [];
        this.captureElements.elements[i].customFields.forEach(m => {
          customFields.push({
            customFieldId: m.customFieldId,
            strValue: m.strValue,
            intValue: m.intValue,
            dblValue: m.dblValue,
            dateValue: m.dateValue,
            dateTimeValue: m.dateTimeValue,
            dataId: m.dataId
          });
        });


        const parameters = {
          elementTypeId: this.captureElements.elements[i].elementType.typeId,
          ref: '',
          CustomFieldValues: customFields,
          Geometry: points
        };

        axios.post('/Element/Create', parameters)
          .then(resp => {
            if (resp.status == 200) {
                this.bCaptureMissingJobcardElementDialog = false;
                this.bCaptureOtherMissingElementDialog = false;
              this.$alertMsg(this.$t('messages.elementHasBeenCreatedSuccessfully'), 2);
            } else {
              console.log(resp);
            }
          })
          .catch(err => {
            this.$alertMsg(err.response.data);
          });
      }
    },
    captureAnotherElement() {
      this.captureElements.currentCaptureMissingElementTab = 'tab-elementTypes';

      this.captureElements.elements.push({
        elementType: {},
        fieldElementType: {},
        systemElementType: {},
        linkedFieldTypeId: -1,
        markers: [],
        customFieldsGroups: [],
        customFields: []
      });

      this.captureElements.selectedElementIdx++;
      this.captureElements.searchElementType = '';
      this.captureElements.searchedElementType = this.elementTypes;
      this.captureElements.selectedElementType = {};
      //this.captureElements.enableMapTab = false;
      //this.captureElements.enableElementDataTab = false;
      this.captureElements.mapLoading = false;

      this.captureElements.askForCaptureAnotherElements = false;
    },
    getElementFieldsGroups() {
      this.componentKey++;
      return this.captureElements.elements[this.captureElements.selectedElementIdx].customFieldsGroups;
    }
  },
}
